'use client';

import { useEffect, useState } from 'react';
import { PWAInstallContext } from './pwaInstallContext';

export default function RootLayout({
  children,
}: {
  children: React.ReactNode
}) {
  // PWA 설치 관련 상태 관리
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
  const [isInstallable, setIsInstallable] = useState(false);
  const [isPWAInstalled, setIsPWAInstalled] = useState(false);

  useEffect(() => {
    // beforeinstallprompt 이벤트 감지 (PWA 설치 가능 여부)
    window.addEventListener('beforeinstallprompt', (e) => {
      // 기본 동작 방지 (자동 팝업 방지)
      e.preventDefault();
      // 이벤트 저장
      setDeferredPrompt(e);
      setIsInstallable(true);
    });

    // 이미 PWA로 실행 중인지 감지
    if (window.matchMedia('(display-mode: standalone)').matches ||
      (window.navigator as any).standalone === true) {
      setIsPWAInstalled(true);
    }

    // appinstalled 이벤트 감지
    window.addEventListener('appinstalled', () => {
      // 설치 완료 후 상태 업데이트
      setIsInstallable(false);
      setIsPWAInstalled(true);
      setDeferredPrompt(null);
    });
  }, []);

  // 설치 프롬프트 표시 함수
  const showInstallPrompt = async () => {
    if (!deferredPrompt) return;

    // 설치 프롬프트 표시
    deferredPrompt.prompt();

    // 사용자의 선택 결과 대기
    const choiceResult = await deferredPrompt.userChoice;

    // 프롬프트 사용 후 참조 정리
    setDeferredPrompt(null);

    // 사용자가 설치를 수락한 경우
    if (choiceResult.outcome === 'accepted') {
      console.log('사용자가 PWA 설치를 수락했습니다');
    } else {
      console.log('사용자가 PWA 설치를 거부했습니다');
      // 추후 다시 설치할 수 있도록 상태 유지
      setIsInstallable(true);
    }
  };

  return (
    <PWAInstallContext.Provider value={{
      deferredPrompt,
      isInstallable,
      isPWAInstalled,
      showInstallPrompt,
    }}>
      <style jsx>{`
        html, body {
          height: 100%;
          margin: 0;
          padding: 0;
          overflow-x: hidden;
        }
        
        body {
          min-height: 150vh; /* 스크롤을 위한 높이 확보 */
        }
      `}</style>

      <style jsx global>{`
        /* 홈페이지에서만 적용되는 링크 스타일 재정의 */
        :root {
          --link-bg: hsl(235, 76%, 86%) !important;
          --link-text: hsl(231, 50%, 34%) !important;
          --link-hover-bg: hsl(235, 86%, 65%) !important;
          --link-hover-text: hsl(0, 0%, 100%) !important;
        }
      `}</style>
      {children}
    </PWAInstallContext.Provider>
  )
}